import { t } from 'i18next';
import { FC } from 'react';

import { useNavigation } from '#/hooks';
import { AppStatus } from '#/service/constants';

import { Status } from './Status';

export const NotFound: FC = () => {
  const { goBack } = useNavigation('NotFound');

  return (
    <Status
      dismissMessage={t('button.goBack')}
      onDismiss={goBack}
      status={AppStatus.Configuration}
      statusMessage={t(`error.missingPage.message`)}
      statusTitle={t(`error.missingPage.title`)}
    />
  );
};
